<template>
  <div class="be-mapunavbl text-left">
    <div class="be-mapunavbl__media" v-if="imageUrl">
      <img :src="imageUrl" class="be-mapunavbl__img" alt="" />
    </div>

    <p class="be-mapunavbl__meta mb-2" v-if="meta">{{ meta }}</p>
    <p class="be-mapunavbl__desc mb-3" v-if="description" v-html="description"></p>

    <p class="be-mapunavbl__message mb-0">{{ message }}</p>
  </div>
</template>

<script>
  import {
    fetchRoomTypeDetail,
    getCachedRoomTypeDetail,
    hasCachedRoomTypeDetail
  } from './digital-map/mapDataCache.js';

  export default {
    name: 'BeMapRoomUnavailable',
    props: {
      roomTypeId: {
        type: [String, Number],
        default: null
      },
      merchantId: {
        type: [String, Number],
        default: null
      },
      // why the room cannot be booked -- owned by the modal, which also has the
      // API's own error message to show in its place
      message: {
        type: String,
        default: ''
      }
    },
    data(){
      return {
        detail: null
      }
    },
    computed: {
      imageUrl(){
        const images = (this.detail && this.detail.image) || [];
        return images.length > 0 ? (images[0].image_url || '') : '';
      },
      meta(){
        if(!this.detail) return '';
        const parts = [];
        if(this.detail.max_guests > 0){
          parts.push(this.detail.max_guests + ' ' + this.$pluralWord(this.detail.max_guests, 'Guest'));
        }
        if(this.detail.room_size && this.detail.room_size != '0'){
          parts.push(this.detail.room_size + 'm²');
        }
        (this.detail.bed || []).forEach((bed) => parts.push(bed.qty + ' ' + bed.name));
        return parts.join(' · ');
      },
      description(){
        return (this.detail && this.detail.description) || '';
      }
    },
    watch: {
      roomTypeId: {
        immediate: true,
        handler(){
          this.resolveDetail();
        }
      }
    },
    methods: {
      /* The map already hydrated every pin from room-type, and mapDataCache
         keeps that for the session -- so the guest sees the room they clicked
         even though search-room has nothing to say about it. */
      resolveDetail(){
        this.detail = null;
        if(!this.$isNotEmptyV2(this.roomTypeId) || !this.$isNotEmptyV2(this.merchantId)) return;

        if(hasCachedRoomTypeDetail(this.merchantId, this.roomTypeId)){
          this.detail = getCachedRoomTypeDetail(this.merchantId, this.roomTypeId);
          return;
        }

        // opened before the map finished hydrating this pin: the fetch is
        // deduped by mapDataCache, and the message alone carries the panel
        // until it lands
        const requestedId = this.roomTypeId;
        fetchRoomTypeDetail(this.merchantId, requestedId).then((detail) => {
          if(requestedId != this.roomTypeId) return;
          this.detail = detail;
        });
      }
    }
  }
</script>

<style scoped>
.be-mapunavbl {
  padding: 4px 0 8px;
}
.be-mapunavbl__media {
  margin-bottom: 12px;
  border-radius: var(--be-v3-radius, 12px);
  overflow: hidden;
}
.be-mapunavbl__img {
  display: block;
  width: 100%;
  max-height: 260px;
  object-fit: cover;
}
.be-mapunavbl__meta {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1a1a2e;
}
.be-mapunavbl__desc {
  font-size: 0.875rem;
  color: #4a4a5a;
  /* merchant copy runs long -- keep the panel about the booking status rather
     than turning it into the room detail page */
  max-height: 120px;
  overflow-y: auto;
}
.be-mapunavbl__message {
  padding: 12px 14px;
  border-radius: var(--be-v3-radius, 12px);
  background: #f4f6f8;
  font-size: 0.875rem;
  font-weight: 600;
  color: #6d6d6d;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeMapRoomUnavailable.vue